module.exports = __webpack_public_path__ + "static/media/mall-category-all.227820f3.png";